import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { resetPassword } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      setMessage('');
      setError('');
      setLoading(true);
      await resetPassword(email);
      setMessage('Check your email for a reset link.');
    } catch (err: any) {
      setError(err.message || 'Could not send a reset email.');
      console.error('Password reset error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ss-sheet ss-auth">
      <p className="ss-kicker">Spin &amp; Solve</p>
      <h1 className="ss-title">Reset password</h1>
      <p className="ss-sub">We’ll email a reset link if that address has an account.</p>

      {error && (
        <div className="ss-error" role="alert">
          {error}
        </div>
      )}

      {message && (
        <div className="alert alert-success" role="status">
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <label htmlFor="email" className="ss-label">
          Email
        </label>
        <input
          type="email"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="ss-input"
          required
          autoComplete="email"
          placeholder="you@example.com"
        />

        <button type="submit" disabled={loading} className="ss-btn ss-btn-primary" style={{ width: '100%' }}>
          {loading ? 'Sending link' : 'Send reset link'}
        </button>
      </form>

      <div className="ss-auth-links">
        <Link to="/login" className="ss-inline-link">
          Back to log in
        </Link>
        <Link to="/signup" className="ss-inline-link">
          Create an account
        </Link>
      </div>
    </div>
  );
};

export default ForgotPassword;
